import { z } from 'zod';

import { Action, actionSchema } from '../schema/Action.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getPostActionUrl } from './constants.ts';

export async function postActions(territorySlug: string, vehicleId: number, payload: Action[]) {
  const validatedData = validateData(z.array(actionSchema), payload, 'Action');
  return await api.post(getPostActionUrl(territorySlug, vehicleId), { actions: validatedData });
}
